import { Link } from 'react-router';
import { Menu } from 'antd';
import { PhoneOutlined, UploadOutlined } from '@ant-design/icons';
import useNavigationKeyManager from 'hooks/useNavigationKeyManager';

const AdminSidebar = () => {
  const navigationItems = [
    {
      key: 'block-phone',
      path: '/admin/block-phone',
      icon: <PhoneOutlined />,
      label: <Link to="/admin/block-phone">Block Phone</Link>,
    },
    {
      key: 'bulk-operations',
      path: '/admin/bulk-operations',
      icon: <UploadOutlined />,
      label: <Link to="/admin/bulk-operations">Bulk Operations</Link>,
    },
  ];

  const [activeRouteKey] = useNavigationKeyManager(navigationItems);

  return (
    <Menu
      mode="inline"
      selectedKeys={activeRouteKey}
      items={navigationItems}
      style={{
        borderInlineEnd: 'none',
      }}
    />
  );
};

export default AdminSidebar;
